import React, { Component } from 'react';
import '../Shared/Style/validation.css'

class ValidationComponent extends Component {
    /* eslint-disable-next-line */
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div className={"validationMessage  align-items-center " + this.props.cssCls}>
                <img className="align-warning-sign-icon" src="/images/NotVerified-Icon.png" alt="warningicon"></img>
                <div className="ValidationText">{this.props.prefixText} {this.props.midText}  </div>
            </div>
        );
    }
}

export default ValidationComponent;
